import { useState, useRef } from 'react';
import ReactCrop, { Crop, PixelCrop, centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

interface ModalCorteImagemProps {
  imagemSrc: string;
  isOpen: boolean;
  onClose: () => void;
  onCropComplete: (imagemCortadaUrl: string) => void;
  aspectRatio?: number; // 1 = Quadrado, 16/9 = Retângulo, etc.
}

function centerAspectCrop(mediaWidth: number, mediaHeight: number, aspect: number) {
  return centerCrop(makeAspectCrop({ unit: '%', width: 90 }, aspect, mediaWidth, mediaHeight), mediaWidth, mediaHeight);
}

export function ModalCorteImagem({ imagemSrc, isOpen, onClose, onCropComplete, aspectRatio = 1 }: ModalCorteImagemProps) {
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const imgRef = useRef<HTMLImageElement>(null);

  if (!isOpen) return null;

  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const { width, height } = e.currentTarget;
    setCrop(centerAspectCrop(width, height, aspectRatio));
  };

  const gerarImagemCortada = async () => {
    if (!completedCrop || !imgRef.current) return;

    const canvas = document.createElement('canvas');
    const image = imgRef.current;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    
    canvas.width = completedCrop.width;
    canvas.height = completedCrop.height;
    const ctx = canvas.getContext('2d');

    if (!ctx) return;

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      completedCrop.width,
      completedCrop.height
    );

    // Converte o canvas para uma URL de imagem (blob)
    const imagemCortadaBase64 = canvas.toDataURL('image/jpeg', 0.9);

    onCropComplete(imagemCortadaBase64);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-md rounded-xl bg-background p-6 shadow-2xl">
        <h3 className="mb-4 text-lg font-bold text-foreground">Ajustar Imagem</h3>
        
        <div className="flex max-h-[60vh] justify-center overflow-auto bg-black rounded-lg">
          <ReactCrop crop={crop} onChange={(_, percentCrop) => setCrop(percentCrop)} onComplete={(c) => setCompletedCrop(c)} aspect={aspectRatio}>
            <img ref={imgRef} alt="Recortar" src={imagemSrc} onLoad={onImageLoad} className="max-w-full" />
          </ReactCrop>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button type="button" onClick={onClose} className="rounded-lg px-4 py-2 text-sm font-semibold text-muted-foreground hover:bg-muted">
            Cancelar
          </button>
          <button type="button" onClick={gerarImagemCortada} className="rounded-lg bg-primary px-4 py-2 text-sm font-bold text-primary-foreground hover:bg-primary/90">
            Salvar Ajuste
          </button>
        </div>
      </div>
    </div>
  );
}